/**
 * 栏目章节
 */
import request from "@/utils/request";
import { clearObjEmptyStr } from "@/utils";
/*
获取栏目信息
*/
export const GetColumnInfo = (params) => {
    return request({
        method: "POST",
        url: "/Api/Column/GetColumnInfo",
        params
    });
};

// 获取栏目下第一级章节信息
export const GetFirstSubChapterInfo = (params) => {
    return request({
        method: "POST",
        url: "/Api/Category/GetFirstSubChapterInfo",
        params
    });
};

// 获取下级章节信息
export const GetSubChapterInfo = (params) => {
    return request({
        method: "POST",
        url: "/Api/Category/GetSubChapterInfo",
        params
    });
};

// 获取自建医学分类列表
export const GetMedicalClass = (params) => {
    return request({
        method: "POST",
        url: "/Api/Medical/GetMedicalClass",
        params
    });
};

// 获取全部自建医学分类列表
export const AllMedicalClass = (params) => {
    return request({
        method: "POST",
        url: "/Website/Basic/GetOrganClassInfo",
        params
    });
};

// 验证充值卡
export const VerifyRechargeCard = (params) => {
    return request({
        method: "POST",
        url: "/Api/User/GetRechargeCardInfo",
        params
    });
};

// 充值卡充值
export const CardRecharge = (params) => {
    return request({
        method: "POST",
        url: "/Api/User/RechargeCard",
        params
    });
};

// 充值记录
export const GetRechargeCardRecord = (params) => {
    return request({
        method: "POST",
        url: "/Api/User/RechargeCardRecord",
        params
    });
};

// 消费记录（充值卡）
export const GetUserConsumeRecord = (params) => {
    return request({
        method: "POST",
        url: "/Api/User/GetUserConsumeRecord",
        params
    });
};

// 获取所有机构
export const GetAllOrgan = (params) => {
    return request({
        method: "POST",
        url: "/Api/User/AllOrgan",
        params
    });
};

// 充值卡充值
export const PurchaseProduct = (params) => {
    return request({
        method: "POST",
        url: "/Api/User/PurchaseProduct",
        params
    });
};

// 获取第一级章节
export const GetFirstSystemCategoryInfo = (params) => {
    return request({
        method: "POST",
        url: "/Api/Category/GetFirstSystemCategoryInfo",
        params
    });
};

// 获取科室分类
export const GetHospitalClassInfo = (params) => {
    return request({
        method: "POST",
        url: "/Manage/Basic/GetHospitalClassInfo",
        params
    });
};

// 获取机构分类
export const GetOrganClassInfo = (params) => {
    return request({
        method: "POST",
        url: "/Website/Basic/GetOrganClassInfo",
        params
    });
};

// 保存机构分类
export const SaveOrganClass = (params) => {
    return request({
        method: "POST",
        url: "/Website/Basic/SaveOrganClass",
        data: clearObjEmptyStr(params)
    });
};

// 删除机构分类
export function DeleteOrganClass(params) {
    return request({
        method: "POST",
        url: "/Website/Basic/DeleteOrganClass",
        params
    });
}

// 获取机构知识点
export const GetOrganPointInfo = (params) => {
    return request({
        method: "POST",
        url: "/Website/Basic/GetOrganPointInfo",
        params: clearObjEmptyStr(params)
    });
};

// 保存机构知识点
export const SaveOrganPoint = (params) => {
    return request({
        method: "POST",
        url: "/Website/Basic/SaveOrganPoint",
        data: clearObjEmptyStr(params)
    });
};

// 删除机构知识点
export function DeleteOrganPoint(params) {
    return request({
        method: "POST",
        url: "/Website/Basic/DeleteOrganPoint",
        params
    });
}

// 获取机构用户组
export const GetOrganGroupInfo = (params) => {
    return request({
        method: "POST",
        url: "/Website/Basic/GetOrganGroupInfo",
        params
    });
};

// 保存机构用户组
export const SaveOrganGroup = (params) => {
    return request({
        method: "POST",
        url: "/Website/Basic/SaveOrganGroup",
        data: clearObjEmptyStr(params)
    });
};

// 删除机构用户组
export function DeleteOrganGroup(params) {
    return request({
        method: "POST",
        url: "/Website/Basic/DeleteOrganGroup",
        params
    });
}

// 用户组导入用户
export function GroupImportUser(params) {
    return request({
        method: "POST",
        url: "/Website/Basic/GroupImportUser",
        params
    });
}
